import React from "react";
import SearchInput from "../controls/search-input";
//import logo from '../../assets/logo.png'
import logoKult from '../../assets/kultmapka.png'
import {Link} from "react-router-dom";
import { switchLanguage } from "../../actions/actions-language";
import {connect} from "react-redux";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import {FiUser} from "react-icons/fi";

const formMain = process.env.REACT_APP_FORM_MAIN
const formAlt = process.env.REACT_APP_FORM_ALT;
const formEn = process.env.REACT_APP_FORM_EN;
const languageMain = process.env.REACT_APP_LANGUAGE_MAIN;
const languageAlt = process.env.REACT_APP_LANGUAGE_ALT;
const languageEn = process.env.REACT_APP_LANGUAGE_EN;

const formToOpen = {
    ru: formAlt,
    by: formMain,
    ua: formMain,
    en: formEn
}

const ControlsHeader = props => {

    const { pathname, language, wording, switchLanguage } = props;
    const { width } = useWindowDimensions();

    console.log(111)
    console.log(wording['heading'])

    return (
        <div>
            <div className='controlsHeaderContainer shadow'>
                <Link to='/'>
                    <div className='mr-20'>
                        {languageMain === 'by' && process.env.REACT_APP_THEME !== 'culture' && <img src={wording['heading']['image']} width={50} alt='logo' />}
                        {languageMain === 'by' && process.env.REACT_APP_THEME === 'culture' && <img src={logoKult} width={64} alt='logo' />}
                        {languageMain === 'ua' && <p className='strong'><span style={{color: '#2558b3'}}>mapa</span><span style={{color: '#f8d849'}}>help</span></p>}
                    </div>
                </Link>
                {(pathname === '/' || pathname === '/catalog') &&
                    <div className='mr-20 d-flex-1 d-web'>
                        <SearchInput pathname={pathname} />
                    </div>
                }
                <div className='d-flex-ac'>
                    {pathname !== '/' &&
                        <div className='mr-15 d-flex'>
                            <Link to='/'><p className='button-link fs-12'>{wording['menu3'][language]}</p></Link>
                        </div>
                    }
                    {(pathname === '/' || pathname === '/catalog') &&
                        <div className='d-flex-ac mr-20'>
                            {<a href={formToOpen[language]} target='_blank' rel='noopener noreferrer'><p
                                className='button-link mr-15 fs-12'>{width > 400 ? wording['menu1'][language] : wording['menu1'][language].split(' ')[0]}</p>
                            </a>}
                            <Link to='about'><p className='button-link mr-20 fs-12'>{wording['menu2'][language]}</p></Link>
                            <Link to='account'><p className='button-link fs-12'><div className={'p-5 w-30 h-30 d-flex-center'} style={{border: '1px #FF0000 solid', borderRadius: 10}}><FiUser size={20} /></div></p></Link>
                        </div>
                    }
                    <div className='w-50'>
                        <select className='select-search w-55' value={language} onChange={(e) => switchLanguage(e.target.value)}>
                            <option value={languageMain}>{languageMain.toUpperCase()}</option>
                            <option value={languageAlt}>{languageAlt.toUpperCase()}</option>
                            {languageEn && <option value={languageEn}>{languageEn.toUpperCase()}</option>}
                        </select>
                    </div>
                </div>
            </div>
        </div>
    );

}

const mapStateToProps = ({ language: { language, wording }}) => {
    return { language, wording };
};

const mapDispatchToProps = (dispatch) => {
    return {
        switchLanguage: switchLanguage(dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ControlsHeader);

